import { getSessionId } from "src/utils/axiosInstance";
import { getToken } from "src/utils/session";

export const appendToken = (headers: Headers) => {
    if (!headers.get("token")) {
      const token = getToken();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
    }
    if (!headers.get("x-session-id"))
      headers.set("x-session-id", getSessionId());
    return headers;
  }